import axios from 'axios';

export const reportReplacementApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/report-replacement`,
    headers: {
        'Content-Type': 'application/json'
    }
})